import _extends from 'babel-runtime/helpers/extends';
import _objectWithoutProperties from 'babel-runtime/helpers/objectWithoutProperties';
/* eslint-disable react/prop-types */
import React from 'react';

import './info.scss';

var type = '@sitebase/info';

var InfoRenderer = function InfoRenderer(_ref) {
  var text = _ref.text,
      imageRight = _ref.imageRight,
      imageLeft = _ref.imageLeft;
  return React.createElement(
    'div',
    { className: 'info-container' },
    React.createElement(
      'div',
      { className: 'info-container--left' },
      imageLeft && React.createElement('img', { src: imageLeft.src, alt: imageLeft.alt || '' })
    ),
    React.createElement('div', { className: 'info-container--center', dangerouslySetInnerHTML: { __html: text } }),
    React.createElement(
      'div',
      { className: 'info-container--right' },
      imageRight && React.createElement('img', { src: imageRight.src, alt: imageRight.alt || '' })
    )
  );
};

export default {
  type: type,
  render: function render(_ref2) {
    var data = _ref2.data;

    var id = data.id,
        props = _objectWithoutProperties(data, ['id']);

    return React.createElement(InfoRenderer, _extends({}, props, { 'data-test-id': '' + type + (id ? '_' + id : '') }));
  }
};
//# sourceMappingURL=info.js.map